import React from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import folderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import {getFileType} from '../../../../core/_util'
import {toast} from 'react-toastify'
import {NoDataPage} from '../../../resources/components/NoDataPage'
import Skeleton from 'react-loading-skeleton'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const RetentionPeriod = ({
  retentionData,
  isLoading,
}: {
  retentionData?: any[]
  isLoading?: boolean
}) => {
  const {formatMessage} = useIntl()
    const [modalContainer, setModalContainer] = React.useState<any>()

  return (
    <div className='card rounded p-4 bg-white'>
      <div className='d-flex justify-content-between align-items-center w-100 px-2'>
        <p className='text-muted m-0'>{formatMessage({id: 'Retention Period Expiry'})}</p>
      </div>
      <div className='overflow-auto' style={{height: '400px'}}>
        {isLoading ? (
          <div className='my-5 mx-1'>
            <div className='mb-4'>
              <Skeleton
                width={'100%'}
                height={50}
                count={5}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          </div>
        ) : !isLoading && (!retentionData || retentionData.length === 0) ? (
          <NoDataPage />
        ) : (
          <>
            {retentionData &&
              retentionData.map((record: any) => (
                <div
                  key={record.recordId}
                  className='d-flex align-items-center justify-content-between my-2 py-2'
                >
                  <div className='d-flex align-items-center'>
                    <img
                      src={getFileType(record.fileName)}
                      alt={record.fileName}
                      height={32}
                      width={32}
                    />
                    <div className='d-flex flex-column ms-4'>
                    <span ref={(node) => setModalContainer(node)}>
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='tooltip'>
                                <p className='m-0'>
                                  {record.documentName.split(".")[0]}
                                </p>
                              </Tooltip>
                            }
                            container={modalContainer}
                          >
                            <p className='font-size-13 m-0'>
                              {record.documentName.split(".")[0].length > 30
                                ? `${record.documentName.split(".")[0]
                                    .substring(0, 30)}...`
                                : record.documentName.split(".")[0]}
                            </p>
                          </OverlayTrigger>
                        </span>
                      <p className='font-size-10 m-0 text-muted'>
                        <span>
                          <img src={folderIcon} alt='drive' height={16} width={16} />
                        </span>

                        {`/${record?.structureClassificationLevelOne.name}/${
                          record?.structureClassificationLevelTwo.name
                        }/${record?.structureClassificationLevelThree.name}`.substring(0,34)}...

                        <img
                          role='button'
                          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-copy.svg')}
                          alt='copy icon'
                          className='ms-2 cursor-pointer'
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/rk/records-and-files/${encodeURIComponent(
                                record?.structureClassificationLevelOne.name
                              )}/${encodeURIComponent(
                                record?.structureClassificationLevelTwo.name
                              )}/${encodeURIComponent(record?.structureClassificationLevelThree.name)}`
                            );
                            toast.success(`${formatMessage({ id: 'Folder path is copied' })}`);
                          }}
                          
                        />
                      </p>
                    </div>
                  </div>
                  <div className='gap-2 '>
                    <p className='font-size-13 m-0'>{record.leftDays} Days</p>
                    <p className='font-size-10 m-0 text-muted'>
                      {formatMessage({id: 'will be expired in'})}
                    </p>
                  </div>
                </div>
              ))}
          </>
        )}
      </div>
    </div>
  )
}

export default RetentionPeriod
